'use client'

import { SubmitCOISClientMatterWizard } from '@repo/ui/SubmitCOISClientMatterWizard'
import { useNotificationStore } from '@repo/store/useNotificationStore'
import { useState, useEffect } from 'react'
import { useWizardStore } from '@repo/store/useWizardStore'
import { useUrlStore } from '@repo/store/useUrlStore'
import { WizardFooter } from '@repo/ui/WizardFooter'
import PropTypes from 'prop-types'

export const NewMatterSummary = ({ updateStepState, wideMode, handlePrevNext, wizardId, testMode = false }) => {
  const [formStatus, setFormStatus] = useState(null)
  const { isNotificationWizard, setIsNotificationWizard, completeNewMatterNotification } = useNotificationStore()
  const { reset: resetWizardStore } = useWizardStore()
  const { navigateWithClientMatterNo } = useUrlStore()

  useEffect(() => {
    if (formStatus && formStatus !== 'error') updateStepState({ status: 'completed', statusText: 'Complete' })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formStatus])

  const splitFormStatus = (formStatus) => {
    const parts = formStatus.split('-')
    if (parts.length !== 2) {
      throw new Error(`Invalid formStatus "${formStatus}". Expected format "clientNo-matterNo".`)
    }
    const [clientNo, matterNo] = parts
    return { clientNo, matterNo }
  }

  const handleSubmit = async () => {
    if (!formStatus || formStatus === 'error') return
    // on success, formStatus will be the new clientMatterNo
    if (isNotificationWizard) {
      const { clientNo, matterNo } = splitFormStatus(formStatus)
      await setIsNotificationWizard(false)
      await completeNewMatterNotification({ clientNo: clientNo, matterNo: matterNo })
    }

    await resetWizardStore()

    // go to default matter page
    navigateWithClientMatterNo({ clientMatterNo: formStatus })
  }

  const handleClickBack = () => {
    handlePrevNext(-1)
  }

  return (
    <div data-testid="NewMatterSummary">
      <SubmitCOISClientMatterWizard wizardId={wizardId} testMode={testMode} onStatusChange={setFormStatus} />
      <WizardFooter
        wideMode={wideMode}
        handleClickContinue={handleSubmit}
        handleClickBack={handleClickBack}
        continueButtonDisabled={!formStatus || formStatus === 'error'}
        continueButtonText="Finish"
        backButtonVisible={!formStatus || formStatus === 'error'}
      />
    </div>
  )
}

NewMatterSummary.propTypes = {
  wideMode: PropTypes.bool,
  handlePrevNext: PropTypes.func,
  wizardId: PropTypes.string,
  testMode: PropTypes.bool,
  updateStepState: PropTypes.func
}
